import { render, staticRenderFns } from "./SearchResultAssigneeInput.vue?vue&type=template&id=13ba27be"
import script from "./SearchResultAssigneeInput.vue?vue&type=script&lang=ts"
export * from "./SearchResultAssigneeInput.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultAssigneeInput.vue?vue&type=style&index=0&id=13ba27be&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports